import { render, staticRenderFns } from "./JVxeCheckboxCell.vue?vue&type=template&id=4ac16215&"
import script from "./JVxeCheckboxCell.vue?vue&type=script&lang=js&"
export * from "./JVxeCheckboxCell.vue?vue&type=script&lang=js&"
import style0 from "./JVxeCheckboxCell.vue?vue&type=style&index=0&id=4ac16215&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports